import { render, staticRenderFns } from "./FormPalveluhakemusBase.vue?vue&type=template&id=0251c16a&scoped=true&"
import script from "./FormPalveluhakemusBase.vue?vue&type=script&lang=js&"
export * from "./FormPalveluhakemusBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0251c16a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0251c16a')) {
      api.createRecord('0251c16a', component.options)
    } else {
      api.reload('0251c16a', component.options)
    }
    module.hot.accept("./FormPalveluhakemusBase.vue?vue&type=template&id=0251c16a&scoped=true&", function () {
      api.rerender('0251c16a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormPalveluhakemusBase.vue"
export default component.exports